import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {IconArrowLeft, IconGenderMale, IconGenderFemale, IconGenderAgender, IconPlus} from "@tabler/icons-react";
import AthletesGroupsMaterial from "../../Components/MainMenu/AthletesGroupsMaterial";


const Groups = () => {
    const [selectedGender, setSelectedGender] = useState(""); // Track selected radio

    const { t } = useTranslation();

    return (
        <div className="p-4 flex flex-col h-full relative">
            <AthletesGroupsMaterial headline={t("athletesGroups.headline")} type="groups" />
            <div className="grow overflow-y-auto overflow-x-hidden flex flex-col gap-8">
            </div>
            <Link to="/athletes/groups/new" className="p-4 rounded-full bg-[var(--dark-color)] text-[var(--light-color)] absolute right-2 bottom-2">
                <IconPlus className="w-6 h-auto" />
                <span className="sr-only">{t("athletesGroups.addNew")}</span>
            </Link>
        </div>
    );
};

export default Groups;